import { render, staticRenderFns } from "./BlogTable.vue?vue&type=template&id=1b2dac58&scoped=true"
import script from "./BlogTable.vue?vue&type=script&lang=js"
export * from "./BlogTable.vue?vue&type=script&lang=js"
import style0 from "./BlogTable.vue?vue&type=style&index=0&id=1b2dac58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2dac58",
  null
  
)

export default component.exports